module.exports = __webpack_public_path__ + "img/矫治器加工-选中.c9a55da3.png";